import { Grid } from '@mui/material'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { ControlledAddressInput } from '../AddressInput/ControlledAddressInput'
import { ControlledCheckbox } from '../ControlledCheckbox'
import { ControlledTextField } from '../ControlledTextField'
import { FieldContainer } from '../FieldContainer'

export const AddressFields = () => {
  const { watch } = useFormContext()
  const sameAsShipping = watch('sameAsShipping')

  return (
    <FieldContainer>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ControlledAddressInput name='address' />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField name='postalCode' label='Postal Code' />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name='addressLine'
            label='Street Name, Building, House No'
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <ControlledCheckbox name='sameAsShipping' label='Same as Shipping' />
        </Grid>
        {!sameAsShipping && (
          <Grid item xs={12}>
            <ControlledTextField
              name='shippingAddress'
              label='Shipping Address'
            />
          </Grid>
        )}
      </Grid>
    </FieldContainer>
  )
}
